import { BaseModel } from "sjs-base-model";

export default class ResourceDistributionByProjectModel extends BaseModel {
  public readonly name: string = "";
  public readonly total_budget: number = 0;
  public readonly pay_to_actor: number = 0;
  public readonly pay_to_cast: number = 0;

  constructor(data: Partial<ResourceDistributionByProjectModel>) {
    super();

    this.update(data);
  }
}
